module.exports = __webpack_public_path__ + "static/media/agnus-dei-original-p4.a27b4494.jpg";